import colors from '@constants/colors';

function IceDefault() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.75" cy="26" r="25.5" fill={colors.gray1} stroke="#0D0F11"/>
            <path
                d="M23.2774 40.3249H25.0362H26.7186H28.4774C31.3493 40.3249 33.6774 37.9968 33.6774 35.1249V33.8249V29.9249C33.6774 29.2069 33.0954 28.6249 32.3774 28.6249H23.2774H19.3774C18.6594 28.6249 18.0774 29.2069 18.0774 29.9249V33.8249V35.1249C18.0774 37.9968 20.4055 40.3249 23.2774 40.3249Z"
                stroke="#0D0F11" strokeWidth="2"/>
            <path
                d="M34.5096 29.9249H36.7975C37.9462 29.9249 38.8775 30.8562 38.8775 32.0049V33.0449C38.8775 34.1937 37.9462 35.1249 36.7975 35.1249H33.6775"
                stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
            <path d="M19.4082 20.3276V25.375" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
            <path d="M17.2227 21.5894L21.5938 24.113" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
            <path d="M17.2227 24.113L21.5938 21.5894" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
            <path d="M25.8977 11.6749V18" stroke="#0D0F11" strokeWidth="1.39013" strokeLinecap="round"/>
            <path d="M23.1589 13.2563L28.6366 16.4189" stroke="#0D0F11" strokeWidth="1.39013" strokeLinecap="round"/>
            <path d="M23.1589 16.4187L28.6366 13.2562" stroke="#0D0F11" strokeWidth="1.39013" strokeLinecap="round"/>
            <path d="M32.3872 20.3276V25.375" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
            <path d="M30.2017 21.5894L34.5728 24.113" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
            <path d="M30.2017 24.113L34.5728 21.5894" stroke="#0D0F11" strokeWidth="1.10931" strokeLinecap="round"/>
        </svg>
  );
}

export default IceDefault;
